var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.948 4.45833L14.948 3.11042C14.9479 2.35908 14.3701 1.75 13.6573 1.75H10.343C9.63016 1.75 9.05228 2.35913 9.0523 3.11051L9.05234 4.45833M14.948 4.45833H9.05234M14.948 4.45833H19.2173C20.3401 4.45833 21.2503 5.42838 21.2503 6.625L21.2502 12.0417H20.5912M9.05234 4.45833H4.78307C3.66028 4.45833 2.75008 5.42838 2.75008 6.625L2.75 12.0417H3.38874M20.5912 12.0417H14.277M20.5912 12.0417L20.6522 19.0833C20.6522 20.28 19.742 21.25 18.6192 21.25H5.38107C4.25828 21.25 3.34808 20.28 3.34808 19.0833L3.38874 12.0417M14.277 12.0417V11.3901C14.277 10.7639 13.7955 10.2563 13.2015 10.2563H10.8801C10.286 10.2563 9.80447 10.7639 9.80447 11.3901V12.0417M14.277 12.0417V12.8059C14.277 13.4321 13.7955 13.9397 13.2015 13.9397H10.8801C10.286 13.9397 9.80447 13.4321 9.80447 12.8059V12.0417M9.80447 12.0417H3.38874",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon01.183e61b717e41c25fcce2cb209911e61.svg";
export { ForwardRef as ReactComponent };